import { useTranslation } from 'react-i18next';

import {
    Checkbox,
    Heading2,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { constants } from '@myphx-engineering/phx-design-system/framework';

import { ConditionalComponent } from '../utility/ConditionalComponent';

type FilterCheckboxGroupProps = {
    withInsurance: boolean;
    toggleWithInsurance: () => void;
    smartPrice: boolean;
    toggleSmartPrice: () => void;
    favorite: boolean;
    toggleFavorite: () => void;
    toggleInstantRouting: () => void;
    instantRouting?: boolean;
    hasPhxBenefitsPlan: boolean;
};

const FilterCheckboxGroup = ({
    withInsurance,
    toggleWithInsurance,
    smartPrice,
    toggleSmartPrice,
    favorite,
    toggleFavorite,
    toggleInstantRouting,
    instantRouting,
    hasPhxBenefitsPlan,
}: FilterCheckboxGroupProps) => {
    const { t } = useTranslation();

    return (
        <>
            <ConditionalComponent condition={hasPhxBenefitsPlan}>
                <Stack gap="xxs">
                    <Heading2>
                        {t('filterAndSort.subtitle.pricingOptions')}
                    </Heading2>

                    <Stack gap={0}>
                        <Checkbox
                            label={t('filterAndSort.checkBox.withInsurance')}
                            onChange={toggleWithInsurance}
                            checked={withInsurance}
                        />
                        <Checkbox
                            label={t('filterAndSort.checkBox.smartPRICE', {
                                tm: constants.unicode.TRADEMARK,
                            })}
                            onChange={toggleSmartPrice}
                            checked={smartPrice}
                        />
                    </Stack>
                </Stack>
            </ConditionalComponent>
            <Stack gap="xxs">
                <Heading2>{t('filterAndSort.subtitle.pharmacies')}</Heading2>
                {instantRouting !== undefined ? (
                    <Checkbox
                        label={t('controlledSubstance.modal.instantRouting')}
                        onChange={toggleInstantRouting}
                        checked={instantRouting}
                    />
                ) : null}
                <Checkbox
                    label={t('filterAndSort.checkBox.favoritePharmacies')}
                    onChange={toggleFavorite}
                    checked={favorite}
                />
            </Stack>
        </>
    );
};

export default FilterCheckboxGroup;
